module.exports = __webpack_public_path__ + "img/communicationsTypes.bc2512ca.svg";